module.exports = __webpack_public_path__ + "img/map-circle2.709d9bf5.svg";